/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import { isCanada, getBrand, scrollToElement } from '@tcp/core/src/utils';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import BrandLogo from '@tcp/web/src/components/common/atoms/BrandLogo';
import config from '@tcp/web/src/components/features/content/Header/config';
import ImageComp from '@tcp/core/src/components/common/atoms/Image';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import withStyles from '../../../../../../common/hoc/withStyles';
import { getIconPath, getImageFilePath } from '../../../../../../../utils';
import styles from '../styles/LoginHeader.styles';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
  myPlaceRewards,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblLoginCreateOrLoginV2,
} from '../../../../../../../utils/labels/globalLogin.labels';
import GlobalStoreLabels, {
  GLOBAL_STORE_LABELS,
  lblStoreLocatorWelcomeTxt,
} from '../../../../../../../utils/labels/globalStore.labels';

const LoginHeader = ({
  className,
  variation,
  fullPage,
  headingLabel,
  subHeadingLabel,
  subHeadingLabel2,
  maskedPhoneNumber,
  isLoginWithOTPEnabled,
  isV2Flow,
  labelGroup,
  loginSelectedOption,
  emailAddress,
  fromPlccICLogin,
  loginFlowUXEnhancementEnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const brand = getBrand();
  let toScroll = useRef(null);
  const { extraConfig } = React.useContext(LabelsContext);
  const { isNewLoginScreen: isNewLoginScreenExtraConfig } = extraConfig || {};
  const isNewLoginScreen = fromPlccICLogin ? true : isNewLoginScreenExtraConfig;
  useEffect(() => {
    if (toScroll && !loginFlowUXEnhancementEnabled) {
      scrollToElement(toScroll);
    } else {
      window?.scrollTo(0, 0);
    }
  }, []);

  const toScrollRef = (ref) => {
    toScroll = ref;
  };

  const myPlaceRewardsLbl = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_ACCESSIBILITY_LABELS}.${myPlaceRewards}`,
    GlobalAccessibilityLabels
  );

  const getLogoElement = () => {
    return (
      <>
        {!isCanada() && !(variation === 'favorites' || variation === 'checkout') && (
          <BodyCopy
            component="div"
            textAlign="center"
            className={`elem-mt-XXL  elem-ml-XXL  elem-mr-XXL ${fullPage ? 'logos' : ''}`}
          >
            {fullPage && (
              <>
                {config[brand] && (
                  <>
                    <BrandLogo
                      alt={config[brand].alt}
                      className="header-brand__home-logo--brand login-test-logo"
                      dataLocator={config[brand].dataLocator}
                      imgSrc={`${getImageFilePath()}/${config[brand].imgSrc}`}
                    />
                  </>
                )}
                <span className="logo-seperator" />
                <BodyCopy component="div" className="my-rewards-img-wrapper">
                  <ImageComp
                    src={getIconPath('my-place-rewards')}
                    className="logo elem-mb-LRG login-test-logo"
                    data-locator="login-mprbanner"
                    alt={myPlaceRewardsLbl}
                  />
                </BodyCopy>
              </>
            )}
            {!fullPage && (
              <ImageComp
                src={getIconPath('my-place-rewards')}
                className="logo elem-mb-LRG login-test-logo"
                data-locator="login-mprbanner"
                alt={myPlaceRewardsLbl}
              />
            )}
          </BodyCopy>
        )}
      </>
    );
  };

  const getLoginOTPLogo = () => {
    return (
      <>
        {!isCanada() ? (
          <BodyCopy component="div" textAlign="center" className="elem-mt-LRG">
            <ImageComp
              src={getIconPath('header__brand-tab-quad')}
              alt="pjp brand logo"
              height="32px"
              width="300xpx"
            />
          </BodyCopy>
        ) : (
          <BodyCopy component="div" textAlign="center" className="elem-mt-XS">
            <ImageComp
              src={getIconPath('header__brand-tab-tcp')}
              alt="tcp brand logo"
              height="24px"
              width="70px"
              className="elem-mr-MED checkout-test-logo"
            />
            <ImageComp
              src={getIconPath('header__brand-tab-gym')}
              alt="gym brand logo"
              height="27px"
              width="72px"
              className="elem-mr-MED checkout-test-logo"
            />
          </BodyCopy>
        )}
      </>
    );
  };

  const getHeading = () => {
    if (labelGroup) {
      return isNewLoginScreen
        ? getLabelFromCopyOrFromTranslation(
            `${GLOBAL_LOGIN_LABELS}.${lblLoginCreateOrLoginV2}`,
            GlobalLoginLabels
          )
        : getLabelFromCopyOrFromTranslation(
            `${GLOBAL_STORE_LABELS}.${lblStoreLocatorWelcomeTxt}`,
            GlobalStoreLabels
          );
    }
    return headingLabel;
  };
  return (
    <div ref={toScrollRef}>
      <BodyCopy component="div" textAlign="center" className={className}>
        {headingLabel && (
          <BodyCopy
            textAlign={fromPlccICLogin ? 'left' : 'center'}
            fontSize={isNewLoginScreen ? 'fs28' : 'fs26'}
            fontWeight="extrabold"
            fontFamily="secondary"
            className={fromPlccICLogin ? 'elem-mt-MED' : 'elem-mt-LRG heading-style '}
            component={'h1'}
          >
            {getHeading()}
            {loginSelectedOption === 'sms' && maskedPhoneNumber && !isNewLoginScreen && (
              <BodyCopy
                textAlign="center"
                fontSize="fs26"
                fontWeight="extrabold"
                fontFamily="secondary"
              >
                {maskedPhoneNumber}
              </BodyCopy>
            )}
            {loginSelectedOption === 'email' && emailAddress && !isNewLoginScreen && (
              <BodyCopy
                textAlign="center"
                fontSize="fs26"
                fontWeight="extrabold"
                fontFamily="secondary"
              >
                {emailAddress}
              </BodyCopy>
            )}
          </BodyCopy>
        )}
        {!isLoginWithOTPEnabled && getLogoElement()}
        {isLoginWithOTPEnabled &&
          !isNewLoginScreen &&
          !isV2Flow &&
          variation !== 'favorites' &&
          getLoginOTPLogo()}
        {subHeadingLabel && (
          <>
            <BodyCopy
              textAlign="center"
              fontSize={'fs18'}
              fontWeight={'extrabold'}
              fontFamily="secondary"
              className={'elem-mt-MED_1 sub-heading-style'}
            >
              {subHeadingLabel}
            </BodyCopy>
          </>
        )}
        {subHeadingLabel2 && (
          <>
            <BodyCopy
              textAlign="center"
              fontSize={'fs16'}
              fontWeight={'semibold'}
              fontFamily="secondary"
              className="elem-mt-XXS sub-heading-style-2"
              color={'gray.800'}
            >
              {subHeadingLabel2}
            </BodyCopy>
          </>
        )}
      </BodyCopy>
    </div>
  );
};

LoginHeader.propTypes = {
  className: PropTypes.string.isRequired,
  variation: PropTypes.string.isRequired,
  fullPage: PropTypes.bool,
  headingLabel: PropTypes.string,
  subHeadingLabel: PropTypes.string,
  maskedPhoneNumber: PropTypes.string,
  isLoginWithOTPEnabled: PropTypes.bool,
  isV2Flow: PropTypes.bool,
  labelGroup: PropTypes.string,
};

LoginHeader.defaultProps = {
  fullPage: false,
  headingLabel: null,
  subHeadingLabel: null,
  maskedPhoneNumber: null,
  isLoginWithOTPEnabled: true,
  isV2Flow: false,
  labelGroup: '',
};

export default withStyles(LoginHeader, styles);
export { LoginHeader as LoginHeaderVanilla };
